import type { Schema } from '@/shared/api/contract';

/**
 * Straight from the contract: cubas.domain.schemas.contacts (contract v10.44, ADR 0038 of
 * the back). The address book fills itself with what is sent; whoever administers adds,
 * corrects and deletes, and keeps the groups.
 */
export type Contact = Schema<'ContactRead'>;
export type ContactWrite = Schema<'ContactWrite'>;
export type ContactChange = Schema<'ContactChange'>;
export type ContactSuggestion = Schema<'ContactSuggestion'>;
export type ContactGroup = Schema<'ContactGroupRead'>;
export type ContactGroupWrite = Schema<'ContactGroupWrite'>;
export type GroupMember = Schema<'GroupMember'>;

/** What a group holds at most (`MAX_GROUP_MEMBERS` of the back). */
export const MAX_GROUP_MEMBERS = 50;

/** «1 persona», «12 personas». */
export function peopleText(count: number): string {
  return `${count} ${count === 1 ? 'persona' : 'personas'}`;
}
